import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import type { PayrollDataField } from '@/types';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import { ref, watch } from 'vue';
    import { useRoles } from '@/composables/useRoles';
    import Role from '@/enums/Role';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';
    import { usePayrollStore } from '@/stores/payroll';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTablePayrollInput',
  props: {
    value: {},
    editableField: {},
    readOnly: { type: Boolean },
    employeeId: {},
    field: {},
    fieldType: {},
    payrollId: {},
    isApproved: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const queryClient = useQueryClient();
    const payrollStore = usePayrollStore();
    const { t } = useI18n();
    const { hasAnyRole } = useRoles();

    const localValue = ref(props.value);

    watch(
        () => props.value,
        (newVal) => {
            localValue.value = newVal;
        },
    );

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: {
            field: string;
            fieldType: string;
            employeeId: number;
            value: number | null;
        }) =>
            axios.post(
                route('v2.salary.payrolls.field-change', { payroll: props.payrollId }),
                formData,
            ),
        onSuccess: (data) => {
            if (
                localValue.value &&
                localValue.value !== 0 &&
                ((data.data.field === 'hourly_rate' && data.data.fieldType === 'amount') ||
                    ['gage', 'lunch_arrangement_monthly', 'fixed_add_ons_monthly'].includes(
                        data.data.field,
                    ))
            ) {
                payrollStore.openModal(
                    data.data.field,
                    data.data.name,
                    props.employeeId,
                    localValue.value,
                );
            }

            if (data.data.isUpdated) {
                queryClient.invalidateQueries({
                    queryKey: [QueryKey.PAYROLL, selectedCompanyId, props.payrollId],
                });
            }
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.error || t('forms.system_error'));
            queryClient.invalidateQueries({
                queryKey: [QueryKey.PAYROLL, selectedCompanyId, props.payrollId],
            });
        },
    });

    function handleBlur() {
        if (localValue.value === props.value) {
            return;
        }

        if (localValue.value && localValue.value < 0) {
            toast.error(t('payrolls.no_negative_value'));
            return;
        }

        mutate({
            field: props.field,
            fieldType: props.fieldType,
            employeeId: props.employeeId,
            value: localValue.value,
        });
    }

return (_ctx: any,_cache: any) => {
  return (localValue.value !== null)
    ? (_openBlock(), _createBlock(ThousandSeparatorInput, {
        key: 0,
        modelValue: localValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
        class: _normalizeClass([
            _unref(hasAnyRole)([_unref(Role).PAYROLL, _unref(Role).SUPER_ADMIN]) &&
            _ctx.editableField.is_updated &&
            'border-accent/50 bg-accent/10'
        , "min-w-24 text-right"]),
        placeholder: localValue.value.toString(),
        "with-decimals": "",
        disabled: _ctx.readOnly || _unref(isPending) || _ctx.isApproved,
        onBlur: handleBlur,
        "hide-zeroes": ""
      }, null, 8, ["modelValue", "class", "placeholder", "disabled"]))
    : _createCommentVNode("", true)
}
}

})